<template>
  <div class="transaction-panel">
    <div class="layout-left d-flex align-items-start flex-column">
      <div class="detail-info mb-auto" v-if="consignment.branch_invoice_tax">
        <p class="data-info">ข้อมูลลูกค้า</p>
        <p class="title-info">หมายเลขสมาชิก (Member No.)</p>
        <p class="data-info">{{ consignment.invoice_tax_payer_number }}</p>
        <p class="title-info">ชื่อลูกค้า (Customer Name)</p>
        <p class="data-info">
          {{ consignment.invoice_tax_name }}
        </p>
        <p class="title-info">โทรศัพท์ (Telephone)</p>
        <p class="data-info">{{ consignment.branch_invoice_tax.telephone }}</p>
        <p class="title-info">หมายเลขสาขา</p>
        <p class="data-info">
          {{ consignment.branch_invoice_tax.branch_register_number }}
        </p>
        <p class="title-info">ที่อยู่ลูกค้า</p>
        <p class="data-info">{{ address }}</p>
        <!-- <p class="title-info">หมายเลขใบเสร็จ (Mim/Pos Ref No.) /-</p>
        <p class="mb-2">{{ consignment.invoice_no }}</p> -->

        <div class="text-center action-desktop">
          <b-button
            variant="primary-color"
            class="w-75"
            @click="getTransaction()"
          >
            ออกใบลดหนี้
          </b-button>

          <b-button
            variant="primary-color"
            class="w-75 mt-3"
            :disabled="consignment.outstanding_amount == 0"
            @click="modalConfirm(true)"
          >
            เคลียร์ Tax ตั้งยอด
          </b-button>
        </div>
      </div>
      <div class="text-center w-100 pb-3 pr-4 action-desktop">
        <b-button variant="primary-color" to="/invoice-consignment">
          ย้อนกลับ
        </b-button>
      </div>
    </div>
    <div class="layout-right">
      <div class="transaction-status px-3">
        <div>
          <p class="text-ref-no">
            INV NO: {{ consignment.invoice_no }}
            <template>
              <b-button @click="printFile(consignment)">
                <font-awesome-icon icon="print" class="pointer text-white" />
                Print
              </b-button>
            </template>
          </p>
          <p class="text-time">
            {{
              $moment(consignment.created_time)
                .add(543, "years")
                .format($formatDateNewFull)
            }}
            สาขา {{ consignment.branch_name }} GP Barcode :
            {{ consignment.gp_barcode_name }}
          </p>
        </div>
        <div class="detail px-2">
          <p
            :class="[
              'text-status',
              consignment.user_transaction_status_id == 1
                ? 'text-success'
                : 'text-danger',
            ]"
          >
            สถานะ: {{ consignment.user_transaction_status_name }}
            <!-- <template v-if="consignment.is_partialable">
              (Partial Return)
            </template> -->
            <template
              v-if="
                consignment.user_transaction_ref_id &&
                consignment.user_transaction_status_id == 1
              "
            >
              (Void/Returned)
            </template>
          </p>
          <p class="text-saleId" v-if="consignment.branch_invoice_tax">
            #{{ consignment.branch_invoice_tax.tax_payer_number }}
            {{ consignment.branch_invoice_tax.name }}
          </p>
        </div>
      </div>
      <b-row cols="5" no-gutters class="head-total h-auto px-3">
        <b-col>
          <div class="bg-secondary">
            <p>Total Amount</p>
            <p>(รวม)</p>
            <p class="points">
              {{ consignment.total_amount | numeral("0,0.00") }}
            </p>
          </div>
        </b-col>
        <b-col>
          <div class="bg-secondary">
            <p>GP Discount</p>
            <p>(ส่วนลด GP)</p>
            <p class="points">
              {{ consignment.gp_discount | numeral("0,0.00") }}
            </p>
          </div>
        </b-col>
        <b-col>
          <div class="bg-secondary">
            <p>Total Amount Exclude VAT</p>
            <p>(มูลค่าไม่รวม VAT)</p>
            <p class="points">
              {{ consignment.total_after_discount | numeral("0,0.00") }}
            </p>
          </div>
        </b-col>
        <b-col>
          <div class="bg-secondary">
            <p>VAT</p>
            <p>(ภาษีมูลค่าเพิ่ม)</p>
            <p class="points">
              {{ consignment.vat | numeral("0,0.00") }}
            </p>
          </div>
        </b-col>
        <b-col>
          <div class="bg-secondary">
            <p>Total Net Amonut</p>
            <p>(ยอดสุทธิ)</p>
            <p class="points">
              {{ consignment.net_amount | numeral("0,0.00") }}
            </p>
          </div>
        </b-col>
      </b-row>
      <template v-if="!isMobile">
        <div class="m-3">
          <b-row class="mx-0 text-center header-products">
            <b-col cols="1" class="header-products-item">
              <p>จำนวน</p>
              <p>Qty</p>
            </b-col>
            <b-col md="4" class="header-products-item text-left">
              <p>รายละเอียดสินค้า/โปรโมชั่น</p>
              <p>Description/Promotion</p>
            </b-col>
            <b-col class="header-products-item">
              <p>ราคาต่อหน่วย</p>
              <p>Unit Price</p>
            </b-col>
            <b-col class="header-products-item">
              <p>ราคารวม</p>
              <p>Total</p>
            </b-col>
            <b-col class="header-products-item">
              <p>ส่วนลด GP</p>
              <p>GP Discount</p>
            </b-col>
            <b-col class="header-products-item">
              <p>ราคาหลังส่วนลด GP</p>
              <p>Total After Discount</p>
            </b-col>
            <b-col class="header-products-item">
              <p>ภาษีมูลค่าเพิ่ม</p>
              <p>Vat</p>
            </b-col>
            <b-col class="header-products-item">
              <p>ราคาสุทธิ</p>
              <p>Net</p>
            </b-col>
          </b-row>
        </div>
        <div class="">
          <div class="item-products m-3 product-list-container">
            <b-row
              v-for="(product, index) in consignment.products"
              :key="index"
              class="product-panel mx-0 mb-2 h-100 py-2"
            >
              <b-col
                cols="1"
                class="border-product d-flex justify-content-center align-items-center"
              >
                <p class="my-0">{{ product.quantity }}</p>
              </b-col>
              <b-col cols="4" class="pointer">
                <b-row>
                  <b-col
                    cols="3"
                    v-if="$store.state.config.show_product_image_on_pos == 1"
                  >
                    <img
                      v-if="
                        product.product_image &&
                        $store.state.config.show_product_image_on_pos == 1
                      "
                      :src="product.product_image"
                      class="img-size img-fluid"
                    />
                    <img
                      v-else
                      src="@/assets/images/noimg.png"
                      alt="no-image-product"
                      class="img-size"
                    />
                  </b-col>
                  <b-col class="ml-2">
                    <p>{{ product.product_barcode }}</p>

                    <p class="product-info">
                      {{ product.product_name }}
                    </p>
                    <p v-if="product.gp_barcode_percent" class="product-info">
                      Group Barcode: {{ product.gp_barcode_name }}
                      {{ product.gp_barcode_percent }}%
                    </p>
                    <p
                      v-if="product.inventory_product_serial_number"
                      class="product-info"
                    >
                      Serial: {{ product.inventory_product_serial_number }}
                    </p>

                    <p class="product-info" v-if="product.gold_type">
                      น้ำหนัก :
                      <span
                        >{{ product.total_weight | numeral("0,0.00") }}
                      </span>
                    </p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                class="price d-flex justify-content-center align-items-center"
              >
                {{ product.price | numeral("0.00") }}
              </b-col>
              <b-col
                class="price d-flex justify-content-center align-items-center"
              >
                {{ product.total_price | numeral("0.00") }}
              </b-col>
              <b-col
                class="price d-flex justify-content-center align-items-center"
              >
                {{ product.gp_discount | numeral("0.00") }}
              </b-col>

              <b-col
                class="price d-flex justify-content-center align-items-center"
              >
                <div>
                  <p>
                    {{ product.after_discount_price | numeral("0,0.00") }}
                  </p>
                  <p
                    v-if="product.sap_price != product.price"
                    class="normal-unit-price"
                  >
                    {{ product.total_price | numeral("0,0.00") }}
                  </p>
                </div>
              </b-col>
              <b-col
                class="price d-flex justify-content-center align-items-center"
              >
                <p>
                  {{ product.vat | numeral("0,0.00") }}
                </p>
              </b-col>
              <b-col class="price justify-content-center align-items-center">
                <p>
                  {{ product.after_discount_price | numeral("0,0.00") }}
                </p>
                <div
                  v-if="product.gold_type"
                  class="d-flex justify-content-center mt-2"
                >
                  <div class="">
                    <b-row class="f-10 p-0">
                      <b-col
                        class="text-right text-nowrap text-primary p-0"
                        cols="7"
                      >
                        มูลค่าทอง
                        <font-awesome-icon
                          :id="`tooltip-gold-variable-${index}`"
                          icon="exclamation-circle"
                          class="pointer icon-exclamation"
                        />
                        <b-tooltip
                          :target="`tooltip-gold-variable-${index}`"
                          placement="left"
                        >
                          ราคาทองประจำวัน ต่อกรัม
                          {{ product.gold_price_per_gram | numeral("0,0.00") }}
                          *
                          {{ product.weight | numeral("0,0.00") }}
                        </b-tooltip>
                      </b-col>

                      <b-col class="text-left">
                        {{ product.gold_value | numeral("0,0.00") }}
                      </b-col>
                    </b-row>

                    <b-row class="f-10 p-0">
                      <b-col
                        class="text-right text-nowrap text-primary p-0"
                        cols="7"
                      >
                        ค่าแรงรวม VAT
                        <font-awesome-icon
                          :id="`vat-tooltip-${index}`"
                          icon="exclamation-circle"
                          class="pointer icon-exclamation"
                        />
                        <b-tooltip
                          :target="`vat-tooltip-${index}`"
                          placement="left"
                        >
                          ค่าแรงรวม = ราคาขายสินค้า - มูลค่าทอง
                        </b-tooltip>
                      </b-col>

                      <b-col class="text-left">
                        {{ product.cost_vat | numeral("0,0.00") }}
                      </b-col>
                    </b-row>

                    <b-row class="f-10 p-0">
                      <b-col
                        class="text-right text-nowrap text-primary p-0"
                        cols="7"
                      >
                        ค่าแรงไม่รวม
                      </b-col>

                      <b-col class="text-left">
                        {{ product.cost | numeral("0,0.00") }}
                      </b-col>
                    </b-row>

                    <b-row class="f-10 p-0">
                      <b-col
                        class="text-right text-nowrap text-primary p-0"
                        cols="7"
                        >VAT
                      </b-col>

                      <b-col class="text-left">
                        {{ product.vat | numeral("0,0.00") }}
                      </b-col>
                    </b-row>
                  </div>
                </div>
                <div v-else class="d-flex justify-content-center mt-2">
                  <div class="">
                    <b-row class="f-10 p-0">
                      <b-col
                        class="text-right text-nowrap text-primary p-0"
                        cols="7"
                        >มูลค่าไม่รวม VAT
                      </b-col>

                      <b-col class="text-left">
                        {{
                          (product.after_discount_price - product.vat)
                            | numeral("0,0.00")
                        }}
                      </b-col>
                    </b-row>

                    <b-row class="f-10 p-0">
                      <b-col
                        class="text-right text-nowrap text-primary p-0"
                        cols="7"
                        >VAT
                      </b-col>

                      <b-col class="text-left">
                        {{ product.vat | numeral("0,0.00") }}
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>
            </b-row>
            <hr />
          </div>
        </div>
      </template>
      <template v-else>
        <b-row
          class="mx-0 my-1 p-2 bg-white product-panel"
          v-for="(product, index) in consignment.products"
          :key="index"
        >
          <b-col
            cols="1"
            class="text-center border-product d-flex align-items-center justyfy-content-center"
          >
            <p>{{ product.quantity }}</p>
          </b-col>

          <b-col class="px-2 pointer text-general text-nowrap">
            <b-row>
              <b-col
                cols="3"
                v-if="$store.state.config.show_product_image_on_pos == 1"
              >
                <img
                  v-if="
                    product.product_image &&
                    $store.state.config.show_product_image_on_pos == 1
                  "
                  :src="product.product_image"
                  class="img-size-sm img-fluid"
                />
                <img
                  v-else
                  src="@/assets/images/noimg.png"
                  alt="no-image-product"
                  class="img-size-sm"
                />
              </b-col>
              <b-col class="ml-2">
                <p>{{ product.barcode }}</p>

                <p class="product-info">
                  {{ product.product_name }}
                </p>
                <p v-if="product.gp_barcode_percent" class="product-info">
                  Group Barcode: {{ product.gp_barcode_name }}
                  {{ product.gp_barcode_percent }}%
                </p>
                <p v-if="product.serial" class="product-info">
                  Serial: {{ product.serial }}
                </p>

                <p class="product-info" v-if="product.gold_type">
                  น้ำหนัก :
                  <span>{{ product.weight | numeral("0,0.00") }} </span>
                </p>
              </b-col>
            </b-row>
          </b-col>

          <b-col class="pr-0 pointer text-right">
            <div>
              <!-- <p>
                {{ product.sap_price | numeral("0,0.00") }}
              </p> -->
              <p class="normal-unit-price">
                {{ product.price | numeral("0,0.00") }}
              </p>
            </div>
          </b-col>
          <b-col cols="3" xl="2" class="price">
            <p v-if="product" class="fs-16">
              {{ product.total_price | numeral("0,0.00") }}
            </p>
          </b-col>
        </b-row>
      </template>
      <!-- cns ja -->
      <template v-if="consignment.cns">
        <div v-for="(cns, i) in consignment.cns" :key="i" class="px-5">
          <div class="transaction-status">
            <div>
              <p class="text-ref-no">
                INV NO:
                <span
                  class="text-underline pointer"
                  @click="$router.push(`/cn-consignment/detail/${cns.id}`)"
                  >{{ cns.invoice_no }}</span
                >

                <b-button @click="printFile(cns)" class="ml-2">
                  <font-awesome-icon icon="print" class="pointer text-white" />
                  Print
                </b-button>
              </p>
              <p class="text-time">
                {{
                  $moment(cns.created_time)
                    .add(543, "years")
                    .format($formatDateNewFull)
                }}
                สาขา {{ consignment.branch_name }}
              </p>
            </div>
            <div class="detail px-2">
              <p
                :class="[
                  'text-status',
                  cns.user_transaction_status_id == 1
                    ? 'text-success'
                    : 'text-danger',
                ]"
              >
                สถานะ: {{ cns.user_transaction_status_name }}
                <!-- <template v-if="consignment.is_partialable">
              (Partial Return)
            </template> -->
                <!-- <template
                  v-if="
                    consignment.user_transaction_ref_id &&
                    consignment.user_transaction_status_id == 1
                  "
                >
                  (Void/Returned)
                </template> -->
              </p>
              <p class="text-saleId" v-if="consignment.branch_invoice_tax">
                #{{ consignment.branch_invoice_tax.tax_payer_number }}
                {{ consignment.branch_invoice_tax.name }}
              </p>
            </div>
          </div>
          <b-row cols="5" no-gutters class="head-total h-auto px-3">
            <b-col>
              <div class="bg-secondary">
                <p>Total Amount</p>
                <p>(รวม)</p>
                <p class="points">
                  {{ cns.total_amount | numeral("0,0.00") }}
                </p>
              </div>
            </b-col>
            <b-col>
              <div class="bg-secondary">
                <p>GP Discount</p>
                <p>(ส่วนลด GP)</p>
                <p class="points">
                  {{ cns.gp_discount | numeral("0,0.00") }}
                </p>
              </div>
            </b-col>
            <b-col>
              <div class="bg-secondary">
                <p>Total Amount Exclude VAT</p>
                <p>(มูลค่าไม่รวม VAT)</p>
                <p class="points">
                  {{ cns.total_after_discount | numeral("0,0.00") }}
                </p>
              </div>
            </b-col>
            <b-col>
              <div class="bg-secondary">
                <p>VAT</p>
                <p>(ภาษีมูลค่าเพิ่ม)</p>
                <p class="points">
                  {{ cns.vat | numeral("0,0.00") }}
                </p>
              </div>
            </b-col>
            <b-col>
              <div class="bg-secondary">
                <p>Total Net Amonut</p>
                <p>(ยอดสุทธิ)</p>
                <p class="points">
                  {{ cns.net_amount | numeral("0,0.00") }}
                </p>
              </div>
            </b-col>
          </b-row>
          <template v-if="!isMobile">
            <div class="m-3">
              <b-row class="mx-0 text-center header-products">
                <b-col cols="1" class="header-products-item">
                  <p>จำนวน</p>
                  <p>Qty</p>
                </b-col>
                <b-col md="4" class="header-products-item text-left">
                  <p>รายละเอียดสินค้า/โปรโมชั่น</p>
                  <p>Description/Promotion</p>
                </b-col>
                <b-col class="header-products-item">
                  <p>ราคาต่อหน่วย</p>
                  <p>Unit Price</p>
                </b-col>
                <b-col class="header-products-item">
                  <p>ราคารวม</p>
                  <p>Total</p>
                </b-col>
                <b-col class="header-products-item">
                  <p>ส่วนลด GP</p>
                  <p>GP Discount</p>
                </b-col>
                <b-col class="header-products-item">
                  <p>ราคาหลังส่วนลด GP</p>
                  <p>Total After Discount</p>
                </b-col>
                <b-col class="header-products-item">
                  <p>ภาษีมูลค่าเพิ่ม</p>
                  <p>Vat</p>
                </b-col>
                <b-col class="header-products-item">
                  <p>ราคาสุทธิ</p>
                  <p>Net</p>
                </b-col>
              </b-row>
            </div>
            <div class="">
              <div class="item-products m-3 product-list-container">
                <b-row
                  v-for="(product, index) in cns.products"
                  :key="index"
                  class="product-panel mx-0 mb-2 h-100 py-2"
                >
                  <b-col
                    cols="1"
                    class="border-product d-flex justify-content-center align-items-center"
                  >
                    <p class="my-0">{{ product.quantity }}</p>
                  </b-col>
                  <b-col cols="4" class="pointer">
                    <b-row>
                      <b-col
                        cols="3"
                        v-if="
                          $store.state.config.show_product_image_on_pos == 1
                        "
                      >
                        <img
                          v-if="
                            product.product_image &&
                            $store.state.config.show_product_image_on_pos == 1
                          "
                          :src="product.product_image"
                          class="img-size img-fluid"
                        />
                        <img
                          v-else
                          src="@/assets/images/noimg.png"
                          alt="no-image-product"
                          class="img-size"
                        />
                      </b-col>
                      <b-col class="ml-2">
                        <p>{{ product.product_barcode }}</p>

                        <p class="product-info">
                          {{ product.product_name }}
                        </p>
                        <p
                          v-if="product.gp_barcode_percent"
                          class="product-info"
                        >
                          Group Barcode: {{ product.gp_barcode_name }}
                          {{ product.gp_barcode_percent }}%
                        </p>
                        <p
                          v-if="product.inventory_product_serial_number"
                          class="product-info"
                        >
                          Serial: {{ product.inventory_product_serial_number }}
                        </p>

                        <p class="product-info" v-if="product.gold_type">
                          น้ำหนัก :
                          <span>{{ product.weight | numeral("0,0.00") }} </span>
                        </p>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col
                    class="price d-flex justify-content-center align-items-center"
                  >
                    {{ product.price | numeral("0.00") }}
                  </b-col>
                  <b-col
                    class="price d-flex justify-content-center align-items-center"
                  >
                    {{ product.total_price | numeral("0.00") }}
                  </b-col>
                  <b-col
                    class="price d-flex justify-content-center align-items-center"
                  >
                    {{ product.gp_discount | numeral("0.00") }}
                  </b-col>

                  <b-col
                    class="price d-flex justify-content-center align-items-center"
                  >
                    <div>
                      <p>
                        {{ product.after_discount_price | numeral("0,0.00") }}
                      </p>
                      <p
                        v-if="product.sap_price != product.price"
                        class="normal-unit-price"
                      >
                        {{ product.total_price | numeral("0,0.00") }}
                      </p>
                    </div>
                  </b-col>
                  <b-col
                    class="price d-flex justify-content-center align-items-center"
                  >
                    <p>
                      {{ product.vat | numeral("0,0.00") }}
                    </p>
                  </b-col>
                  <b-col
                    class="price justify-content-center align-items-center"
                  >
                    <p>
                      {{ product.after_discount_price | numeral("0,0.00") }}
                    </p>
                    <div
                      v-if="product.gold_type"
                      class="d-flex justify-content-center mt-2"
                    >
                      <div class="">
                        <b-row class="f-10 p-0">
                          <b-col
                            class="text-right text-nowrap text-primary p-0"
                            cols="7"
                          >
                            มูลค่าทอง
                            <font-awesome-icon
                              :id="`tooltip-gold-variable-${index}`"
                              icon="exclamation-circle"
                              class="pointer icon-exclamation"
                            />
                            <b-tooltip
                              :target="`tooltip-gold-variable-${index}`"
                            >
                              ราคาทองประจำวัน ต่อกรัม
                              {{
                                product.gold_price_per_gram | numeral("0,0.00")
                              }}
                              *
                              {{ product.weight | numeral("0,0.00") }}
                            </b-tooltip>
                          </b-col>

                          <b-col class="text-left">
                            -{{ product.gold_value | numeral("0,0.00") }}
                          </b-col>
                        </b-row>

                        <b-row class="f-10 p-0">
                          <b-col
                            class="text-right text-nowrap text-primary p-0"
                            cols="7"
                          >
                            ค่าแรงรวม VAT
                            <font-awesome-icon
                              :id="`vat-tooltip-${index}`"
                              icon="exclamation-circle"
                              class="pointer icon-exclamation"
                            />
                            <b-tooltip :target="`vat-tooltip-${index}`">
                              ค่าแรงรวม = ราคาขายสินค้า - มูลค่าทอง
                            </b-tooltip>
                          </b-col>

                          <b-col class="text-left">
                            {{ product.cost_vat | numeral("0,0.00") }}
                          </b-col>
                        </b-row>

                        <b-row class="f-10 p-0">
                          <b-col
                            class="text-right text-nowrap text-primary p-0"
                            cols="7"
                          >
                            ค่าแรงไม่รวม
                          </b-col>

                          <b-col class="text-left">
                            {{ product.cost | numeral("0,0.00") }}
                          </b-col>
                        </b-row>

                        <b-row class="f-10 p-0">
                          <b-col
                            class="text-right text-nowrap text-primary p-0"
                            cols="7"
                            >VAT
                          </b-col>

                          <b-col class="text-left">
                            {{ product.vat | numeral("0,0.00") }}
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                    <div v-else class="d-flex justify-content-center mt-2">
                      <div class="">
                        <b-row class="f-10 p-0">
                          <b-col
                            class="text-right text-nowrap text-primary p-0"
                            cols="7"
                            >มูลค่าไม่รวม VAT
                          </b-col>

                          <b-col class="text-left">
                            {{
                              (product.after_discount_price - product.vat)
                                | numeral("0,0.00")
                            }}
                          </b-col>
                        </b-row>

                        <b-row class="f-10 p-0">
                          <b-col
                            class="text-right text-nowrap text-primary p-0"
                            cols="7"
                            >VAT
                          </b-col>

                          <b-col class="text-left">
                            {{ product.vat | numeral("0,0.00") }}
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <hr />
              </div>
            </div>
          </template>
          <template v-else>
            <div v-if="cns.product">
              <b-row
                class="mx-0 my-1 p-2 bg-white product-panel"
                v-for="(product, index) in cns.products"
                :key="index"
              >
                <b-col
                  cols="1"
                  class="text-center border-product d-flex align-items-center justyfy-content-center"
                >
                  <p>{{ product.quantity }}</p>
                </b-col>

                <b-col class="px-2 pointer text-general text-nowrap">
                  <b-row>
                    <b-col
                      cols="3"
                      v-if="$store.state.config.show_product_image_on_pos == 1"
                    >
                      <img
                        v-if="
                          product.product_image &&
                          $store.state.config.show_product_image_on_pos == 1
                        "
                        :src="product.product_image"
                        class="img-size-sm img-fluid"
                      />
                      <img
                        v-else
                        src="@/assets/images/noimg.png"
                        alt="no-image-product"
                        class="img-size-sm"
                      />
                    </b-col>
                    <b-col class="ml-2">
                      <p>{{ product.barcode }}</p>

                      <p class="product-info">
                        {{ product.product_name }}
                      </p>
                      <p v-if="product.gp_barcode_percent" class="product-info">
                        Group Barcode: {{ product.gp_barcode_name }}
                        {{ product.gp_barcode_percent }}%
                      </p>
                      <p v-if="product.serial" class="product-info">
                        Serial: {{ product.serial }}
                      </p>

                      <p class="product-info" v-if="product.gold_type">
                        น้ำหนัก :
                        <span>{{ product.weight | numeral("0,0.00") }} </span>
                      </p>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col class="pr-0 pointer text-right">
                  <div>
                    <!-- <p>
                {{ product.sap_price | numeral("0,0.00") }}
              </p> -->
                    <p class="normal-unit-price">
                      {{ product.price | numeral("0,0.00") }}
                    </p>
                  </div>
                </b-col>
                <b-col cols="3" xl="2" class="price">
                  <p v-if="product" class="fs-16">
                    {{ product.total_price | numeral("0,0.00") }}
                  </p>
                </b-col>
              </b-row>
            </div>
          </template>
          <div class="text-center d-flex justify-content-between"></div>
          <!-- <hr class="" v-if="i != consignment.consignment_void.length - 1" /> -->
        </div>
      </template>
    </div>
    <ModalAlertConfirm
      ref="modalAlertConfirm"
      :msg="confirmMessage.msg"
      :text="confirmMessage.text"
      @confirm="(val, test) => clearTax(val)"
    />
    <ModalCreateCn
      ref="modalCreateCn"
      @success="getData"
      :data="form"
    ></ModalCreateCn>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";

import InputSelect from "@/components/inputs/InputSelect";
import ModalCreateCn from "./components/ModalCreateCn.vue";

export default {
  components: { ModalCreateCn, ModalAlertConfirm },
  computed: {
    invoice_no() {
      let filtered = this.transactionList.filter(
        (item) => this.form.transactionId == item.id
      );
      filtered = filtered.map((item, index) => item.invoice_no);
      return filtered[0] || "";
    },
    selectedTransaction() {
      let filtered = this.transactions.find(
        (item) => this.form.transactionId == item.id
      );

      return filtered;
    },
    ...mapGetters(["isLoading"]),
    ...mapGetters({
      mainLoading: "getMainLoading",
      branchId: "getBranchId",
      pointSystem: "getPointSystem",
      isFullPos: "getIsFullPos",
      permission: "getRolePermission",
    }),
  },
  data() {
    return {
      isMobile: false,
      id: this.$route.params.id,
      form: {
        transactionId: 0,
        is_store_credit: false,
      },
      transactionList: [],
      consignment: {},
      filter: {
        page: 1,
      },
      confirmMessage: {},
      totalPage: 1,
      address: "",
      cnList: [],
      isClearText: false,
    };
  },
  async created() {
    await this.getData();
  },
  mounted() {
    this.onResize();
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 768;
    },
    hasPromotion(index) {
      return this.transactions[index].product.some((el) => el.promotion.length);
    },

    async getData() {
      await this.axios
        .get(`${this.$baseUrl}/InvoiceConsignment/${this.id}`)
        .then(async (data) => {
          if (data.result == 1) {
            this.consignment = data.detail;

            this.form = data.detail;
            let _address = data.detail.branch_invoice_tax;

            if (
              _address.address.includes("กรุงเทพ") ||
              _address.provicne == "Bangkok"
            ) {
              this.address = `${_address.address} แขวง${_address.subdistrict}  เขต${_address.district} จ.${_address.province} ${_address.zip_code}`;
            } else {
              this.address = `${_address.address} ต.${_address.subdistrict}  อ.${_address.district} จ.${_address.province} ${_address.zip_code}`;
            }
          } else this.warningAlert(data.message);
        });
    },
    async exportTransaction(consignment) {
      await this.axios
        .get(`${this.$baseUrl}/Export/export_customer_point/${consignment.id}`)
        .then(async (data) => {
          var link = document.createElement("a");
          document.body.appendChild(link);
          link.setAttribute("type", "hidden");
          link.href = "data:application/pdf;base64," + data.detail;
          link.setAttribute(
            "download",
            `transaction-${consignment.invoice_no}.pdf`
          );
          link.setAttribute("target", `_blank`);
          link.click();
        });
    },
    async printFile(consignment) {
      await this.axios
        .get(`${this.$baseUrl}/InvoiceConsignment/Report/${consignment.id}`, {
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response], { type: "application/pdf" });
          const blobUrl = URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = `${consignment.invoice_no}.pdf`;
          link.click();

          this.printReceipt(response);
        });
    },
    async printReceipt(Base64String) {
      await this.axios
        .post("http://localhost:30033/api/PrintReceipt", { Base64String })
        .then(async (data) => {
          if (data.result !== 1) {
            this.warningAlert(data.message);
          }
        })
        .catch((err) => {});
    },
    async getTransaction() {
      this.$refs.modalCreateCn.show();
    },
    modalConfirm(isClearText) {
      this.confirmMessage = {
        msg: "ยืนยันการทำรายการ",
        text: "หลังจากยืนยันแล้วจะไม่สามารถแก้ไขได้",
      };
      this.isClearText = isClearText;
      this.$refs.modalAlertConfirm.show(true);
    },
    async clearTax() {
      await this.$store.dispatch("setMainLoading", true);
      let res = await this.axios.post(
        `${this.$baseUrl}/InvoiceConsignment/CN/ClearTax`,
        {
          ref_invoice_consignment_id: this.id,
          search: "",
          branch_id: this.form.branch_id,
        }
      );
      if (res.result) {
        this.successAlert(res.message);
        this.getData();
      }
      await this.$store.dispatch("setMainLoading", false);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .layout-left {
  width: 300px;
  background: #f7f7f7;
  height: calc(100vh - 46px);
  position: relative;
  font-family: Kanit-Medium !important;

  .detail-info {
    padding: 20px;

    .title-info {
      font-size: 14px;
      color: grey;
    }

    .data-info {
      color: #333;
      font-size: 16px;
      text-align: left;
      margin-bottom: 15px;
    }
  }
}

::v-deep .layout-right {
  width: calc(100% - 300px);
  height: calc(100vh - 46px);
  overflow: auto;

  .transaction-status {
    display: flex;
    justify-content: space-between;
    padding: 12px 0;

    .detail {
      text-align: right;
    }
  }

  .text-ref-no {
    font-family: Kanit-Medium !important;
    font-size: 20px;
  }

  .text-time,
  .text-saleId {
    font-family: Kanit-Medium !important;
    font-size: 14px;
  }

  .text-status {
    font-family: Kanit-Medium !important;
    font-size: 18px;
  }

  .text-status.text-success {
    color: #3c763d !important;
  }

  .head-total {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;

    p {
      text-align: center;
      color: var(--primary-color) !important;
      font-size: 14px;
      font-weight: 600;
    }

    .col:first-of-type {
      padding-left: 0;
    }

    .col {
      flex: 1;
    }

    .bg-secondary {
      height: 100%;
      padding: 15px 0;
      background: var(--secondary-color) !important;
    }

    .points {
      font-size: 14px;
    }
  }

  .product-list-container {
    overflow: auto;
    height: calc(100% - 46px - 89px - 87px - 40px);
    position: relative;

    .wrap-no-product {
      width: 100%;
      height: 100%;
      display: -ms-flexbox !important;
      display: flex !important;
      -ms-flex-pack: center !important;
      justify-content: center !important;
      -ms-flex-align: center !important;
      align-items: center !important;

      .no-product {
        text-align: center;
        font-size: 20px;
        padding: 15px;
        background-color: #f7f7f7;
        border-radius: 5px;
        color: #dcdcdc;
        width: 450px;
      }
    }
  }

  .header-products {
    font-size: 14px;
    font-weight: bold;
    gap: 4px;

    .header-products-item {
      padding: 0px;
    }
  }

  .product-panel {
    background-color: rgb(244, 244, 244) !important;
  }

  .product-panel.active {
    background-color: var(--secondary-color) !important;
  }

  .item-products {
    color: #707070;
    font-size: 16px;
    border-radius: 8px;
    font-family: Kanit-Medium !important;

    svg {
      color: #000;
    }

    .price {
      font-size: 14px;
      text-align: center;
    }

    .product-info {
      font-size: 12px !important;
    }

    span {
      font-size: 12px;
      color: #707070 !important;
    }

    .normal-unit-price {
      text-decoration: line-through;
    }
  }
}

::v-deep .btn-link {
  border-color: transparent !important;
  background-color: transparent !important;
  text-decoration: underline !important;
  padding: 5px 0;
  color: #707070 !important;
}

.transaction-panel {
  display: flex;
}

.action-desktop {
  display: block;
}

.action-mobile {
  display: none;
}

@media (max-width: 1200px) {
  ::v-deep .layout-right {
    .head-total {
      p {
        font-size: 12px;
      }
    }
  }
}

@media (max-width: 768px) {
  .transaction-panel {
    display: block;

    .layout-left {
      width: 100%;
      height: 100%;

      .detail-info {
        width: 100%;
      }
    }

    .layout-right {
      width: 100%;
      height: 100%;

      .transaction-status {
        display: block;

        .detail {
          text-align: left;
        }
      }
    }

    .action-desktop {
      display: none;
    }

    .action-mobile {
      display: flex;
      flex-direction: column;
      gap: 16px;
      align-items: center;
      margin-bottom: 16px;
      width: 100%;
    }
  }
}

.f-14 {
  font-size: 14px !important;
}

.img-size {
  width: 80px;
  height: 80px;
}

.img-size-sm {
  width: 50px;
  height: 50px;
}
</style>
